import { Component, OnInit, Inject } from '@angular/core';
import { AdminService } from '../services/admin.service';

import { NgForm, ValidatorFn } from '@angular/forms';
import { RolePermissions } from '../../shared/models/rolePermissions.interface';
import { Permissions } from '../../shared/models/permissions.interface';
import { Role } from '../../shared/models/role.interface';

import { finalize } from 'rxjs/operators';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { RolePermission } from '../../shared/models/role.permission.enum';
import { AbstractBiditComponent } from '../../shared/controls/abstract.bidit.component';
import { DeviceDetectorService } from 'ngx-device-detector';
import { HttpErrorResponse } from '@angular/common/http';
import { RoleModule } from '../../shared/models/role.module.enum';


@Component({
  selector: 'app-edit',
  templateUrl: './role.component.html',
  styleUrls: ['./role.component.scss']
})
export class RoleComponent extends AbstractBiditComponent implements OnInit {

  constructor(private adminService: AdminService, deviceDetectorService: DeviceDetectorService, public dialogRef: MatDialogRef<RoleComponent>, @Inject(MAT_DIALOG_DATA) public data: any)
  {
    super(deviceDetectorService);
  }

  quoteOnly: boolean;
  role: Role;
  rolePermissions: RolePermissions[];

  readOnlyRole?: number = undefined;

  errors: string;
  isRequesting: boolean;
  selectedPermissions: number[];

  ngOnInit() {

    let roleId: number = this.data.id;
    if (roleId == null) {
      this.role = {} as Role;
      this.role.role_IsActive = true;
    }
    else {
      this.adminService.getRole(roleId)
        .subscribe({
          next: (data) => {
            this.role = data;
          }
        });
    }

    this.adminService.getRolePermissions(roleId)
      .subscribe({
        next: (data) => {
          this.rolePermissions = data;

          this.readOnlyRole = undefined;

          this.rolePermissions.forEach(rp => {
            rp.permissions.forEach(p => {
              if (p.isSelected && (p.perm_ID == RolePermission.FieldTechnician || p.perm_ID == RolePermission.Salesperson_NonBIDIT))
                this.readOnlyRole = p.perm_ID;
            });
          });
          this.applyReadOnlyRole();
        }
      });

    this.quoteOnly = AdminService._authUserSource.value.isQuoteOnly;
  }

  displayRole(rolePerm: RolePermissions): boolean {
    if (!this.quoteOnly) return true;

    switch (rolePerm.module_ID) {
      case RoleModule.Jobs:
        return false;
      default:
        return true;
    }
  }

  displayPerm(permission: Permissions): boolean {
    if (!this.quoteOnly) return true;

    switch (permission.perm_ID) {
      case RolePermission.FieldTechnician:
        return false;
      default:
        return true;
    }
  }

  getPermissions(roleId: number) {
    this.adminService.getRolePermissions(roleId)
      .subscribe({
        next: (data) => {
          this.rolePermissions = data;
        }
      });
  }

  applyRole(permission: Permissions) {
    if (permission.perm_ID == RolePermission.Salesperson_NonBIDIT || permission.perm_ID == RolePermission.FieldTechnician) {
      this.readOnlyRole = permission.isSelected ? permission.perm_ID : undefined;
      this.applyReadOnlyRole();
    }
  }

  applyReadOnlyRole() {
    if (this.readOnlyRole) {
      // deselect all other permissions
      this.rolePermissions.forEach(rp => {
        rp.permissions.forEach(p => {
          p.isSelected = (p.perm_ID == this.readOnlyRole);
        });
      });
    }
  };

  saveRole(form: NgForm) {
    console.log('in role onSubmit: ', this.role);
    this.errors = '';
    this.buildSelectedPermissions();
    if (this.selectedPermissions == null || this.selectedPermissions.length == 0) {
      this.errors = $localize`At least 1 permission must be selected`; 
      return;
    }

    if (form.valid) {
      this.isRequesting = true;
      this.role.dealer_ID = this.adminService.getDealerId();
      this.adminService.saveRole(this.role)
        .pipe(finalize(() => this.isRequesting = false))
        .subscribe({
          next: (result) => {
            // if the user is a dealer user... apply permissions
            if (result) {
              this.applyRolePermissions(result);
            }
            else {
              this.dialogRef.close();
            }
          },
          error: (error: string) => {
            this.errors = error;
          }
        });
    }
  }

  applyRolePermissions(roleId) {
    console.log('in applypermissions onSubmit: ', roleId);
    this.errors = '';


    this.adminService.saveRolePermissions(roleId, this.selectedPermissions)
      .pipe(finalize(() => this.isRequesting = false))
      .subscribe({
        next: (result) => {
          if(result) {
            this.dialogRef.close(this.role);
          }
            else {
            error: (error: string) =>this.errors = error
          }
        },
        error: (error: string) => {
          this.errors = error;
        }
      });
  }

  buildSelectedPermissions() {
    this.selectedPermissions = [];
    this.rolePermissions.forEach((value) => {
      value.permissions.forEach((value) => {
        if (value.isSelected) {
          this.selectedPermissions.push(value.perm_ID);
        }
      })
    });   
  }

  onNoClick(): void {
    this.dialogRef.close();
  }
}
